module.exports = __webpack_public_path__ + "img/main_20.00e1a8fe.jpg";